/**
 * HelpTooltip — Phase 4 contextual tooltip.
 *
 * Renders a small `<Info />` icon that links to `/help#<anchor>` and, on hover,
 * shows a brief description of the related help section. Designed to be placed
 * next to UI elements that are not self-explanatory (filters, modes, etc.).
 */
import React from "react";
import { Link } from "react-router-dom";
import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export default function HelpTooltip({
  anchor,
  label,
  testId,
  side = "top",
  className = "",
}) {
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Link
            to={`/help#${anchor}`}
            data-testid={testId || `help-tooltip-${anchor}`}
            className={`inline-flex items-center text-muted-foreground transition-colors hover:text-foreground ${className}`}
            aria-label={label}
          >
            <Info className="h-3.5 w-3.5" />
          </Link>
        </TooltipTrigger>
        <TooltipContent side={side} className="max-w-xs text-xs">
          {label}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
